import { render } from "./BetConfirmationDetail.vue?vue&type=template&id=2d22e7bd&scoped=true"
import script from "./BetConfirmationDetail.vue?vue&type=script&lang=js"
export * from "./BetConfirmationDetail.vue?vue&type=script&lang=js"

import "@/assets/scss/ticket/betConfirmationDetail.scss?vue&type=style&index=0&id=2d22e7bd&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d22e7bd"]])

export default __exports__